{{custom-wizard-topic-selector
  topics=this.topics
  category=this.field.category
  onChange=(action "setValue")
  options=(hash maximum=this.field.limit)
}}